import React from 'react';
import { Column, ListTable } from '@/components/pages/dashboard/tiles/bottomTile/bottomTileTables/ListTable';
import { Organisation } from '@/wpt-lib/interfaces/Organisation';
import { Input, Switch } from '@chakra-ui/react';

interface Props {
    organisations: (Organisation & { changed?: boolean })[];
    onUpdate: (organisation: Organisation) => void;
}

const OrganisationEditorTable = ({ organisations, onUpdate }: Props) => {
    const Columns: Column<Organisation & { changed?: boolean }>[] = [
        {
            name: 'Name',
            getData: (o) => o.name,
            highlight: (o) => !!o.changed,
        },
        {
            name: 'Workday Alt Hierarchy ID',
            getData: (o) => (
                <Input
                    type="text"
                    value={o.workdayAltHierarchyId ?? ''}
                    placeholder="not set"
                    onChange={(e) =>
                        onUpdate({
                            ...o,
                            workdayAltHierarchyId: e.target.value === '' ? null : e.target.value,
                        })
                    }
                />
            ),
            width: '30%',
        },
        {
            name: 'Active',
            getData: (o) => (
                <Switch
                    isChecked={!o.inactive}
                    onChange={() => onUpdate({ ...o, inactive: !o.inactive })}
                    size="md"
                    colorScheme="blue"
                />
            ),
            width: '5%',
        },
    ];

    return <ListTable tableCaption="Organisation Units" columns={Columns} getActions={() => []} data={organisations} />;
};

export default OrganisationEditorTable;
